import styled from 'styled-components';

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 6px 6px 0px 0px;
  object-fit: cover;
`;
